import Box from "react-raster";
import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Container from "../Container";
import { Copy, Eyebrow, H1, H2, H3 } from "../Typography";

const FullWidthWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 80vh;
`;

const BackgroundImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
`;

const BackgroundImage = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
  filter: ${({ $imageMask }) => ($imageMask ? "brightness(50%)" : "none")};
  position: absolute;
`;

const Cta = styled.a`
  background-color: ${({ theme, $bgColor }) => theme.colours[$bgColor]};
  color: ${({ theme, $color }) => theme.colours[$color]};
  font-family: ${({ theme }) => theme.fontFamilyMono};
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  padding: 18px 32px;
  border-radius: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  margin-bottom: 20px;
  width: fit-content;

  &:hover {
    background-color: ${({ theme }) => theme.colours.green};
    color: ${({ theme }) => theme.colours.black};
  }
`;

function ImpactStoryJumbotron({
  backgroundImage,
  cta,
  title,
  titleElement,
  eyebrow,
  description,
  hasBottomMargin,
  textColor,
  imageMask,
}) {
  let titleEl = <H2 $colour={textColor}>{title}</H2>;

  if (titleElement === "h1") {
    titleEl = (
      <H1
        $colour={textColor}
        style={{ marginBottom: "0px", fontSize: "62px", lineHeight: "68px" }}
      >
        {title}
      </H1>
    );
  } else if (titleElement === "h3") {
    titleEl = <H3 $colour={textColor}>{title}</H3>;
  }

  return (
    <FullWidthWrapper>
      {backgroundImage && (
        <BackgroundImageContainer>
          <BackgroundImage
            $imageMask={imageMask}
            image={getImage(backgroundImage)}
            alt={title}
          />
        </BackgroundImageContainer>
      )}
      <Container
        hasBottomMargin={hasBottomMargin}
        gridRowGap={0}
        paddingTop={["30px", "100px"]}
      >
        <Box cols={[6, 12]} marginTop={["50px"]}>
          {eyebrow && <Eyebrow colour={textColor}>{eyebrow}</Eyebrow>}
        </Box>
        <Box cols={[6, 12]} marginTop={["50px"]} maxWidth={["100%", "75%"]}>
          {titleEl}
        </Box>
        <Box
          cols={[6, 12]}
          marginTop={["32px"]}
          marginBottom={cta ? "0" : "50px"}
          maxWidth={["100%", "75%"]}
        >
          <Copy colour={textColor} large>
            {description}
          </Copy>
        </Box>
        {cta && (
          <Box cols={[6, 12]} marginTop={["30px"]} marginBottom={["100px"]}>
            <Cta
              $color={textColor === "white" ? "black" : "white"}
              $bgColor={textColor === "white" ? "white" : "black"}
              href={cta.ctaUrl}
            >
              {cta.ctaLabel}
            </Cta>
          </Box>
        )}
      </Container>
    </FullWidthWrapper>
  );
}

export default ImpactStoryJumbotron;
